import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaArrayDefinition } from './TypedDefinition'

export const SchemaArrayPlugin = createSchemaPlugin(
  'Schema.Array',
  SchemaArrayDefinition
)
